
import React, {useEffect, useState} from 'react';

import {FaArrowRight, FaTimes} from 'react-icons/fa';



const Team = () => {
    useEffect(()=>{
document.title = "Décor & Accessories | Pinnacle Concepts Limited";
},[]);


  return (
    <section className='section-cover team-cover equip-cover' >
         <div className='content-container products-container'>
          
          <h2 className="home-h2 furniture-h2">Décor & Accessories</h2>
             {/* <p className='about-intro-p'>Exotic Furniture</p> */}
         
            <div className='services-container-new'>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/6.jpg' class='item-image'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/001</h3>
          </article>
                <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/17.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/002</h3>
          </article>
          <article className='single-service-new'>
    
              <div className='tools-slides-cover'>
                {/* <Tool1></Tool1> */}
                <img src='./images/18.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/003</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/45.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/004</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/46.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/005</h3>
          
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/74.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/006</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/270.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/007</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/271.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/008</h3>
          </article>
          <article className='single-service-new'>
         
              <div className='tools-slides-cover'>
                {/* <Tool2></Tool2> */}
                <img src='./images/272.jpg' class='item-image item-image-a'></img>
              </div>
            <h3 className='skill-h3 service-h3-new'>PC/DA/009</h3>
          </article>
      </div>
         </div>
    </section>
  )
}

export default Team